import { Container } from 'react-bootstrap';
import DataDisplay from '../components/DataDisplay';
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import useStore from '../useStore';

export const ProfileDetails = () => {
    const { accounts, instance } = useMsal();
    const userEmail = useStore((state) => state.userEmail);
    const setUserEmail = useStore((state) => state.setUserEmail);
    const activeAccount = instance.getActiveAccount() || accounts[0] || null;

    useEffect(() => {
        if (activeAccount) {
            const emails = activeAccount.idTokenClaims.emails;
            if (emails && emails.length > 0) {
                const email = emails[0];
                console.log('Email captured in ProfileDetails:', email);
                if (!userEmail) {
                    setUserEmail(email);
                }
            } else {
                console.error('No email found in idTokenClaims');
            }
        }
    }, [activeAccount, setUserEmail, userEmail]);

    return (
        <Container>
            {
                activeAccount ?
                <DataDisplay />
                :
                <p>No profile data available</p> 
            }
        </Container>
    );
};
